import React from 'react'
import Divider from '@material-ui/core/Divider'
import Drawer from '@material-ui/core/Drawer'
import Hidden from '@material-ui/core/Hidden'
import Sidebar from '../../components/Main/Sidebar'
import { connect } from 'react-redux'
import IconButton from '@material-ui/core/IconButton'
import MenuIcon from '@material-ui/icons/Menu'
import BaseContainer, { selector } from 'containers/BaseContainer'
import MenuToggleAction from '../../actions/MenuToggleAaction'

class NavDrawer extends BaseContainer {
    toggleDrawer = () => {
        this.props.dispatch(MenuToggleAction.toggleMenu({
            status: !this.props.data.menuToggle.status
        }))
    }

    render() {
        let { classes, route, data } = this.props

        if (!data.menuToggle.status) {
            return null
        }
        
        return (
            <nav className={classes.drawer}>
                <Hidden smDown implementation="css">
                    <Drawer
                        classes={{
                            paper: classes.drawerPaper,
                            paperAnchorLeft: classes.paperAnchorLeft
                        }}
                        variant="permanent"
                        open
                    >
                        <div className={classes.toolbar}>
                            <IconButton
                                className={classes.navIconButton}
                                color="inherit"
                                aria-label="Open drawer"
                                onClick={this.toggleDrawer}
                            >
                                <MenuIcon />
                            </IconButton>
                        </div>
                        <Divider />
                        <Sidebar route={route} />
                    </Drawer>
                </Hidden>
            </nav>
        )
    }
}

const mapStateToProps = state => {
    return {
        data: selector(state, "menuToggle", {})
    }
}

export default connect(mapStateToProps)(NavDrawer)